import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownSelectionComponent} from "./dropdown-selection.component";
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    DropdownSelectionComponent
  ],
  imports: [
    CommonModule,
    ChappsCommonAngularLibraryModule,
    TranslateModule
  ],
  exports: [
    DropdownSelectionComponent
  ]
})
export class DropdownSelectionModule {
}
